<div class="fx-justify-center fx-align-center fx-col w-full">
  <img [src]="authMethodsService.config?.templateImgUrl || 'assets/header-azzurro.svg'">
</div>
<div class="text-grey-400 h4 text-capitalize mt-10 mx-auto">
  {{ title }}
</div>
<ng-content>
</ng-content>
